// Straight to Paytrail, without the extra "Maksutapa" page (experimental.directpayment).
//
// After "Varaa ja maksa" PaymentOptions.js shows a page with Paytrail's provider button(s), Paytrail's
// terms, "Vuoro varattu alustavasti ... 10 minuuttia" and "Peru maksu". The customer has already chosen
// the method on the checkout (paymentv3-init narrows Paytrail's list to it), so the page makes them
// click the same bank again - or, for a benefit card, pick Visa/Mastercard/Amex. With the switch on:
//   - the checkout (Payments.js) shows the 10-minute notice and Paytrail's terms link instead;
//   - PaymentOptions submits the chosen provider's form at once.
// Kept: a refused payment still shows its page (init runs first), and an embedded booking (iframe)
// still shows the page - opening Paytrail in a new window needs a click there.
// Cancelling at Paytrail frees the provisional booking at once (falcon paymentv3.js cancelOrderlines).
//
// On test hosts ?directpayment=1|0 overrides the venue's setting, to try it on any venue.

const TEST_HOSTS = ['utest.cintoia.com', 'localhost']

// The gateways whose init answers Paytrail's provider list.
export const DIRECT_GATEWAYS = ['pc', 'paytrail', 'paytrail-benefits']

// location: { hostname, search } (window.location)
export const directPaymentEnabled = (appconfig, location) => {
  const loc = location || {}
  if (TEST_HOSTS.includes(loc.hostname)) {
    let fromUrl = null
    try {
      fromUrl = new URLSearchParams(loc.search || '').get('directpayment')
    } catch (e) {
      fromUrl = null
    }
    if (fromUrl === '1') return true
    if (fromUrl === '0') return false
  }
  return Boolean(appconfig && appconfig.experimental && appconfig.experimental.directpayment === true)
}

// The provider form to submit without asking, or null to show the page as before:
// - the only provider left (init narrowed the list to the chosen bank or wallet);
// - for a card-only list (Paytrail benefit cards: Visa / Mastercard / Amex, all id 'creditcard', one
//   card form where the brand is read from the number), the first of them.
export const directProvider = (providers) => {
  const list = Array.isArray(providers) ? providers.filter((p) => p && p.url && Array.isArray(p.parameters)) : []
  if (list.length === 1) return list[0]
  if (list.length > 1 && list.every((p) => p.id === 'creditcard')) return list[0]
  return null
}
